import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-waiting',
    templateUrl: './waiting.component.html',
    styleUrl: './waiting.component.scss',
    standalone: false
})
export class WaitingComponent {

  @Input() success: boolean = false;
  @Input() cancel: boolean = false;

}
